module.exports = __webpack_public_path__ + "img/thumbnail-frozen.770d840f.jpg";